import React from "react";

export const IconAirConditioning = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m12 1.5v21m2.7056-18.75c-0.8165 0.49216-1.7522 0.75152-2.7056 0.75-0.9534 0.00152-1.8891-0.25784-2.7056-0.75m0 16.5c0.81714-0.4908 1.7524-0.75 2.7056-0.75s1.8885 0.2592 2.7056 0.75m6.3877-13.5-18.187 10.5m17.59-7.0312c-0.8337-0.46243-1.526-1.143-2.0025-1.9687-0.4766-0.82575-0.7194-1.7656-0.7026-2.7188m-14.289 8.25c0.83376 0.4624 1.526 1.143 2.0025 1.9687 0.47654 0.8258 0.71942 1.7656 0.70262 2.7189m-3.3014-11.719 18.187 10.5m-17.59-7.0312c0.83376-0.46243 1.526-1.143 2.0025-1.9687s0.71942-1.7656 0.70262-2.7188m14.289 8.25c-0.8337 0.4624-1.526 1.143-2.0025 1.9687-0.4766 0.8258-0.7194 1.7656-0.7026 2.7189"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconAirConditioning;
